import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { thelittlething } from '../../assets/assets';
import { useAuthStore } from '../../store/authStore';
import { getUserOrders } from '../../services/order.service';
import { getSavedGigs } from '../../services/gig.service';

const Update = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const { data: ordersData, isLoading: ordersLoading } = useQuery({
    queryKey: ['orders', 'update-banner'],
    queryFn: () => getUserOrders({ type: 'purchases' }),
    enabled: !!user
  });

  const { data: savedGigs, isLoading: savedLoading } = useQuery({
    queryKey: ['saved-gigs', 'update-banner'],
    queryFn: getSavedGigs,
    enabled: !!user
  });

  if (ordersLoading || savedLoading) return null;

  const activeOrder = (ordersData?.orders || []).find(
    order => order.status === 'pending' || order.status === 'in-progress'
  );

  const hasBookmarks = (savedGigs || []).length > 0;

  if (!activeOrder && !hasBookmarks) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // dd/mm/yyyy
  };

  return (
    <div className="mx-0 my-3 bg-[#174568] text-white p-2 md:p-3 rounded-[10px] flex items-center justify-between">
      <div>
        <h1 className="text-[17px] md:text-xl font-semibold mb-1">Welcome back, {user?.firstName || 'User'}</h1>
        <p className="text-[12px] md:text-[13px] font-light">
          {activeOrder ? (
            <>
              Your project: <span className="font-medium">{activeOrder.title}</span> should be done on the <span className="font-medium">{formatDate(activeOrder.deliveryDate)}</span> if nothing changes.{' '}
              <button 
                onClick={() => navigate(`/clients/messages/${activeOrder.chatId?._id || activeOrder.chatId}`)}
                className="underline"
              >
                ask for update
              </button>
            </>
          ) : (
            <>
              You have {savedGigs.length} saved {savedGigs.length === 1 ? 'project' : 'projects'} you might want to look into.{' '}
              <button 
                onClick={() => navigate('/clients/projects')}
                className="underline"
              >
                view saved
              </button>
            </>
          )}
        </p>
      </div>
      
      <div className="hidden sm:block">
        <img 
          src={thelittlething} 
          alt="Project illustration" 
          className="w-24 md:w-32 h-auto"
          draggable={false}
        />
      </div>
    </div>
  );
};

export default Update;